import { Controller } from "@hotwired/stimulus"

// name_birthdate.html.erb / name_birthdate_residence.html.erb (registration step) の
// 姓名 + 生まれ年 (+ お住まい) validation controller (#1833 PR 8c、#2192 で prefecture 追加)。
//
// 旧 inline JS の `initNameBirthdateValidation` parity:
// - 姓 / 名 not empty (trim 比較)
// - 生まれ年: 4 桁 + 1900 以上 + 18 歳以上 (currentYear - 18 >= year)
// - 3 条件すべて満たすとき submit を enable
//
// prefecture target は **optional**。_gd variant (#2192) の name_birthdate_residence では
// お住まいプルダウンが同 form 内にあるため未選択なら submit を disable するが、既存
// name_birthdate には target が無く `hasPrefectureTarget === false` で常に valid 扱いになる
// (既存 view の挙動は不変)。
//
// scope: form 自体に置く (input 全部 + submit が form 内に閉じる)。
//
// Rule of Three: age cutoff (18 歳) / lower bound (1900) は hardcoded。
export default class extends Controller {
  static targets = ["lastName", "firstName", "birthYear", "prefecture", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    const nameValid = this.#isNameValid()
    const yearValid = this.#isYearValid()
    const prefectureValid = this.#isPrefectureValid()
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !(nameValid && yearValid && prefectureValid)
    }
  }

  #isNameValid() {
    if (!this.hasLastNameTarget || !this.hasFirstNameTarget) return false
    return this.lastNameTarget.value.trim() !== "" && this.firstNameTarget.value.trim() !== ""
  }

  // 生まれ年: 4 桁 + 1900 以上 + 18 歳以上の年 (= currentYear - 18 以下)
  #isYearValid() {
    if (!this.hasBirthYearTarget) return false
    const raw = this.birthYearTarget.value
    if (raw.length !== 4) return false
    const year = parseInt(raw, 10)
    if (isNaN(year)) return false
    const maxYear = new Date().getFullYear() - 18
    return year >= 1900 && year <= maxYear
  }

  // お住まい: target が存在しない view (既存 name_birthdate) では常に true を返す。
  #isPrefectureValid() {
    if (!this.hasPrefectureTarget) return true
    return this.prefectureTarget.value !== ""
  }
}
